// Remove only previously observed Complete System gifts after their parent leaves.
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const fetchCart = window.fetch.bind(window);
  let parents = new Set();
  const removedParents = new Set();
  let timer;
  let pending = Promise.resolve();
  const metadata = (item) => {
    try { return JSON.parse(item.properties && item.properties.__kaching_bundles); } catch (_) { return null; }
  };
  const identity = (data) => data && data.id && data.v ? JSON.stringify([data.id, data.v]) : null;
  async function inspect() {
    const response = await fetchCart(root + 'cart.js', {credentials: 'same-origin', cache: 'no-store'});
    if (!response.ok) return;
    const cart = await response.json();
    const items = cart.items || [];
    const current = new Set(items.filter(item => String(item.product_id) === '9221577441436')
      .map(item => identity(metadata(item))).filter(Boolean));
    for (const id of parents) if (!current.has(id)) removedParents.add(id);
    for (const id of current) removedParents.delete(id);
    parents = current;
    let changed = false;
    for (const item of items) {
      const data = metadata(item);
      if (!data || data.deal !== 'QuKT' || !data.gift || !removedParents.has(identity(data))) continue;
      const result = await fetchCart(root + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({id: item.key, quantity: 0}),
      });
      if (!result.ok) throw new Error('System gift removal failed');
      changed = true;
    }
    if (changed && window.cart && typeof window.cart.getCart === 'function') window.cart.getCart();
  }
  function schedule() {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      pending = pending.then(inspect).catch(error => console.error('Smooche system gifts:', error));
    }, 100);
  }
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0] && args[0].url;
    // Capture parents before a destructive update, including immediate removals.
    const destructive = url && /\/cart\/(?:change|update|clear)(?:\.js)?(?:\?|$)/.test(url);
    const before = destructive ? fetchCart(root + 'cart.js', {
      credentials: 'same-origin', cache: 'no-store',
    }).then(response => response.ok ? response.json() : null).then(cart => {
      for (const item of (cart && cart.items) || []) {
        if (String(item.product_id) !== '9221577441436') continue;
        const id = identity(metadata(item));
        if (id) parents.add(id);
      }
    }).catch(() => {}) : Promise.resolve();
    const result = destructive ? before.then(() => fetchCart(...args)) : fetchCart(...args);
    if (url && /\/cart\/(?:add|change|update|clear)(?:\.js)?(?:\?|$)/.test(url)) {
      result.then(response => { if (response.ok) schedule(); }).catch(() => {});
    }
    return result;
  };
  ['theme:cart:loaded', 'theme:cart:added'].forEach(name => document.addEventListener(name, schedule));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, {once: true});
  else schedule();
})();
(() => {
  // Kaching may add one-time gift lines before the parent arrives.
  if (/\/products\/complete-reverse-aging-system-for-mature-women\/?$/.test(window.location.pathname)) return;

  // The test product uses the same serum gift offer for Buy Once and subscriptions.
  const serumProducts = new Set(['9248261210268', '9163492425884', '9308772401308', '9191878361244']);
  const foundationProducts = new Set(['8758851895452', '8462448984220']);
  const serumGiftVariant = '47239194837148';
  const foundationGiftVariant = '45555084853404';
  const serumFoundationGiftVariant = '47476695335068';
  const foundationBrushVariant = '46674691588252';
  const mysteryGiftVariants = new Set([serumGiftVariant, foundationGiftVariant]);
  const serumGiftVariants = new Set([serumGiftVariant, serumFoundationGiftVariant]);
  const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cartUrl = `${cartRoot}cart.js`;
  const changeUrl = `${cartRoot}cart/change.js`;
  const addUrl = `${cartRoot}cart/add.js`;
  const originalFetch = window.fetch.bind(window);
  const giftTemplates = new Map();
  const templateStorageKey = 'smooche-gift-templates-v2';
  const templateLifetime = 30 * 60 * 1000;
  const templateKey = (variant, bundle) => JSON.stringify([variant, bundle.v, bundle.deal]);
  // Preserve observed free-gift offers across navigation, without parent IDs.
  try {
    const saved = JSON.parse(window.sessionStorage.getItem(templateStorageKey));
    if (saved && Date.now() - saved.savedAt < templateLifetime && Array.isArray(saved.entries)) {
      for (const [key, bundle] of saved.entries) {
        const [variant] = JSON.parse(key);
        if ((mysteryGiftVariants.has(variant) || variant === serumFoundationGiftVariant) &&
          bundle && bundle.gift && key === templateKey(variant, bundle)) giftTemplates.set(key, bundle);
      }
    }
  } catch (_) {}
  const failedGiftAdds = new Set();
  let timer;
  let dirty = false;
  let active = null;
  let replayingCheckout = false;

  function bundleData(item) {
    try {
      return JSON.parse(item.properties && item.properties.__kaching_bundles) || null;
    } catch (_) {
      return null;
    }
  }

  function rememberGifts(items) {
    for (const item of items) {
      const variant = String(item.variant_id);
      if (!mysteryGiftVariants.has(variant) && variant !== serumFoundationGiftVariant) continue;
      const bundle = bundleData(item);
      if (Number(item.final_price) !== 0 || !bundle || !bundle.gift) continue;
      const {id, ...template} = bundle;
      giftTemplates.set(templateKey(variant, template), template);
    }
    try {
      window.sessionStorage.setItem(templateStorageKey, JSON.stringify({
        savedAt: Date.now(), entries: Array.from(giftTemplates),
      }));
    } catch (_) {}
  }

  function matchingParent(items, gift) {
    const variant = String(gift.variant_id);
    const productIds = serumGiftVariants.has(variant) ? serumProducts : foundationProducts;
    const giftBundle = bundleData(gift);
    if (!giftBundle) return items.find((item) => productIds.has(String(item.product_id)));
    return items.find((item) => {
      const parentBundle = bundleData(item);
      return productIds.has(String(item.product_id)) && parentBundle &&
        parentBundle.id === giftBundle.id && parentBundle.v === giftBundle.v;
    });
  }

  function missingGift(items, variant) {
    const productIds = serumGiftVariants.has(variant) ? serumProducts : foundationProducts;
    const parent = items.find((item) => {
      const bundle = bundleData(item);
      return productIds.has(String(item.product_id)) && bundle &&
        giftTemplates.has(templateKey(variant, bundle)) &&
        !failedGiftAdds.has(`${variant}:${bundle.id}`);
    });
    if (!parent) return null;
    const template = giftTemplates.get(templateKey(variant, bundleData(parent)));
    const bundle = {...template, id: bundleData(parent).id};
    return {variant, bundle};
  }

  function nextChange(cart) {
    const items = cart.items || [];
    // Kaching owns the Complete System offer in both purchase modes. Its gifts
    // can have different bundle metadata, so leave this entire cart to Kaching.
    if (items.some((item) => String(item.product_id) === '9221577441436')) return null;
    rememberGifts(items);
    const hasSerum = items.some((item) => serumProducts.has(String(item.product_id)));
    const hasFoundation = items.some((item) => foundationProducts.has(String(item.product_id)));
    const gifts = items.filter((item) => {
      const variant = String(item.variant_id);
      return mysteryGiftVariants.has(variant);
    });
    const keptGift = gifts.find((item) => {
      const variant = String(item.variant_id);
      return Number(item.final_price) === 0 &&
        matchingParent(items, item) &&
        ((variant === serumGiftVariant && hasSerum) ||
          (variant === foundationGiftVariant && hasFoundation));
    });

    for (const gift of gifts) {
      if (gift !== keptGift) return {id: gift.key, quantity: 0};
    }
    if (keptGift && keptGift.quantity !== 1) {
      return {id: keptGift.key, quantity: 1};
    }

    if (!keptGift) {
      const gift = (hasSerum && missingGift(items, serumGiftVariant)) ||
        (hasFoundation && missingGift(items, foundationGiftVariant));
      if (gift) return {addGift: gift};
    }

    const serumFoundationGifts = items.filter((item) =>
      String(item.variant_id) === serumFoundationGiftVariant);
    const keptSerumFoundationGift = serumFoundationGifts.find((item) =>
      Number(item.final_price) === 0 && matchingParent(items, item));
    for (const gift of serumFoundationGifts) {
      if (gift !== keptSerumFoundationGift) return {id: gift.key, quantity: 0};
    }
    if (keptSerumFoundationGift && keptSerumFoundationGift.quantity !== 1) {
      return {id: keptSerumFoundationGift.key, quantity: 1};
    }
    if (!keptSerumFoundationGift && hasSerum) {
      const gift = missingGift(items, serumFoundationGiftVariant);
      if (gift) return {addGift: gift};
    }

    const brushes = items.filter((item) => String(item.variant_id) === foundationBrushVariant);
    for (const brush of brushes) {
      if (!hasFoundation || brush !== brushes[0]) return {id: brush.key, quantity: 0};
    }
    if (brushes[0] && brushes[0].quantity !== 1) {
      return {id: brushes[0].key, quantity: 1};
    }
    return null;
  }

  async function readCart() {
    const response = await originalFetch(cartUrl, {credentials: 'same-origin', cache: 'no-store'});
    if (!response.ok) throw new Error(`Cart read failed: ${response.status}`);
    return response.json();
  }

  async function repairCart() {
    let cart = await readCart();
    let changed = false;
    for (let attempts = 0; attempts < 20; attempts += 1) {
      const change = nextChange(cart);
      if (!change) return changed;
      const url = change.addGift ? addUrl : changeUrl;
      const body = change.addGift ? {
        items: [{
          id: Number(change.addGift.variant),
          quantity: 1,
          properties: {__kaching_bundles: JSON.stringify(change.addGift.bundle)},
        }],
      } : change;
      const response = await originalFetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify(body),
      });
      if (!response.ok) throw new Error(`Gift correction failed: ${response.status}`);
      const result = await response.json();
      if (result.errors) throw new Error('Gift correction was rejected');
      cart = change.addGift ? await readCart() : result;
      if (change.addGift && !(cart.items || []).some((item) =>
        String(item.variant_id) === change.addGift.variant &&
        Number(item.final_price) === 0 && matchingParent(cart.items, item))) {
        failedGiftAdds.add(`${change.addGift.variant}:${change.addGift.bundle.id}`);
      }
      changed = true;
    }
    throw new Error('Gift correction did not settle');
  }

  function refreshCart() {
    if (window.cart && typeof window.cart.getCart === 'function') {
      window.cart.getCart();
    } else if (window.location.pathname.replace(/\/$/, '') === `${cartRoot}cart`.replace(/\/$/, '')) {
      window.location.reload();
    }
  }

  function flush(force = false) {
    if (timer) window.clearTimeout(timer);
    timer = null;
    if (force) dirty = true;
    if (active) return active;
    active = (async () => {
      while (dirty) {
        dirty = false;
        if (await repairCart()) refreshCart();
      }
    })().finally(() => {
      active = null;
      if (dirty) schedule();
    });
    return active;
  }

  function schedule() {
    dirty = true;
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      flush().catch((error) => console.error('Smooche gift correction:', error));
    }, 150);
  }

  function showCheckoutError(button) {
    const holder = button.closest('[data-cart-form]') || button.parentElement;
    if (!holder) return;
    let message = holder.querySelector('[data-gift-correction-error]');
    if (!message) {
      message = document.createElement('p');
      message.setAttribute('data-gift-correction-error', '');
      message.setAttribute('role', 'alert');
      holder.appendChild(message);
    }
    message.textContent = 'We could not update your gift. Please try checkout again.';
  }

  // Observe all theme and bundle cart mutations without changing their responses.
  window.fetch = function (...args) {
    const result = originalFetch(...args);
    const url = typeof args[0] === 'string' ? args[0] : args[0] && args[0].url;
    if (url && /\/cart\/(?:add|change|update|clear)(?:\.js)?(?:\?|$)/.test(url)) {
      result.then((response) => {
        if (response.ok) schedule();
      }).catch(() => {});
    }
    return result;
  };

  ['theme:cart:loaded', 'theme:cart:added'].forEach((name) => {
    document.addEventListener(name, schedule);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, {once: true});
  } else {
    schedule();
  }

  // Finish any pending correction before a normal cart checkout click.
  document.addEventListener('click', (event) => {
    if (replayingCheckout) return;
    const button = event.target.closest('[data-cart-form] [name="checkout"]');
    if (!button || button.disabled) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    flush(true).then(() => {
      replayingCheckout = true;
      try {
        const current = button.isConnected ? button : document.querySelector('[data-cart-form] [name="checkout"]');
        if (current) current.click();
      } finally {
        replayingCheckout = false;
      }
    }).catch((error) => {
      console.error('Smooche gift correction:', error);
      showCheckoutError(button);
    });
  }, true);

  // The cart page can also submit with Enter instead of a checkout click.
  document.addEventListener('submit', (event) => {
    if (replayingCheckout || !event.target.matches('[data-cart-form]')) return;
    const form = event.target;
    const button = event.submitter || form.querySelector('[name="checkout"]');
    if (!button || button.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    flush(true).then(() => {
      replayingCheckout = true;
      try {
        form.requestSubmit(button);
      } finally {
        replayingCheckout = false;
      }
    }).catch((error) => {
      console.error('Smooche gift correction:', error);
      showCheckoutError(button);
    });
  }, true);
})();
